import { render, staticRenderFns } from "./DateTimeStamp.vue?vue&type=template&id=d9882b48&scoped=true&"
import script from "./DateTimeStamp.vue?vue&type=script&lang=js&"
export * from "./DateTimeStamp.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeStamp.vue?vue&type=style&index=0&id=d9882b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9882b48",
  null
  
)

export default component.exports